import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 修改白名单
const modifyWhiteList = obj => new Promise((resolve, reject) => {
    const {
        editWhiteForm,
        token
    } = obj;
    request({
        url: apis.yunwei_server_white_list_modify + '?token=' + token,
        data: editWhiteForm
    }).then(res => {
        resolve(res);
    })
});

// 全局登录拦截
const modifyGlobalLoginBlock = obj => new Promise((resolve, reject) => {
    const {
        globalLoginBlockForm,
        token
    } = obj;
    request({
        url: apis.yunwei_server_global_login_block_modify + '?token=' + token,
        data: globalLoginBlockForm
    }).then(res => {
        resolve(res);
    })
});

// 修改一键加群
const modifyJoinKey = obj => new Promise((resolve, reject) => {
    const {
        joinQQModifyForm,
        token
    } = obj;
    request({
        url: apis.yunwei_server_join_modify + '?token=' + token,
        data: joinQQModifyForm
    }).then(res => {
        resolve(res);
    })
});

const modifyLoginConfiguration = obj => new Promise((resolve, reject) => {
    const {
        modifyForm,
        token
    } = obj;
    request({
        url: apis.yunwei_login_configuration_modify + '?token=' + token,
        data: {
            configurationVals:modifyForm
        }
    }).then(res => {
        resolve(res);
    })
});

// 修改sdk异常公告
const modifySdkError = obj => new Promise((resolve, reject) => {
    const {
        sdkErrorModifyForm,
        token
    } = obj;
    console.log(sdkErrorModifyForm);
    request({
        url: apis.yunwei_server_sdk_error_modify + '?token=' + token,
        data: sdkErrorModifyForm
    }).then(res => {
        resolve(res);
    })
});

// 修改登录服异常公告
const modifyLoginError = obj => new Promise((resolve, reject) => {
    const {
        loginErrorModifyForm,
        token
    } = obj;
    request({
        url: apis.yunwei_server_login_error_modify + '?token=' + token,
        data: loginErrorModifyForm
    }).then(res => {
        resolve(res);
    })
});

// 创建全服登陆服/通信服
const saveYunweiServer = obj => new Promise((resolve, reject) => {
    const {
        nodeServerForm,
        token
    } = obj;
    request({
        url: apis.yunwei_server_save + '?token=' + token,
        data: nodeServerForm
    }).then(res => {
        resolve(res);
    })
});

// 修改排队速率和队列长度
const modifyLoginQueue = obj => new Promise((resolve, reject) => {
    const {
        changeLoginQueueForm,
        token
    } = obj;
    request({
        url: apis.yunwei_server_login_queue_modify + '?token=' + token,
        data: changeLoginQueueForm
    }).then(res => {
        resolve(res);
    })
});

export default {
    saveYunweiServer,
    modifyWhiteList,
    modifyGlobalLoginBlock,
    modifyJoinKey,
    modifyLoginConfiguration,
    modifySdkError,
    modifyLoginError,
    modifyLoginQueue
}



// WEBPACK FOOTER //
// ./src/service/yunwei_server_api.js